const POST_CONSTANTS = {
    POSTS_ON_PAGES: 9,
    PAGINATION_MAX_BUTTONS: 8,
    POSTS_IN_WIDGET: 3
}

export default POST_CONSTANTS
